import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const numberFormats = {
    'en-AU': {
        currency: {
            style: 'currency',
            currency: 'AUD',
            maximumFractionDigits: 0,
            minimumFractionDigits: 0
        }
    }
}

const i18n = new VueI18n({
    locale: 'en-AU',
    fallbackLocale: 'en-AU',
    // messages,
    numberFormats
});

Vue.filter('currencyWithoutCents', value => {
    return i18n.n(Math.floor(value / 100), 'currency');
});
